import { apiFetch, API_BASE_URL } from './client';

// 注意：後端 /api/wallet/me 已過濾掉內部成本欄位
// （usdToTwd / profitRate / modelCalls），使用者端不取得這些資訊
export interface WalletPointLog {
  _id: string;
  delta: number;
  reason: string;
  refType?: string;
  refId?: string;
  createdAt: string;
}

export interface MyWalletInfo {
  walletId: string;
  year: number;
  month: number;
  initialPoints: number;
  currentPoints: number;
  expiresAt: string;
  pointLogs: WalletPointLog[];
}

export async function fetchMyWallet(): Promise<MyWalletInfo> {
  const res = await apiFetch(`${API_BASE_URL}/wallet/me`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((err as any).error || '無法取得點數資訊');
  }
  return res.json();
}
